import styles from "./InlineAccount.module.scss";
import { useContext } from "react";
import { HorizontalSpacer } from "../utils/Utils";
import { InstitutionLogo } from "./InstitutionLogo";
import { InstitutionsContext } from "../firebaseio/InstitutionsContext";
import { AccountsContext } from "../firebaseio/AccountsContext";
import { BreadAccount, BreadInstitution } from "breadcommon";

export function InlineAccount({
  account_id,
  logoGap = 15,
  logoSize = 18.5,
  accounts,
  institutions,
}: {
  account_id: string | null | undefined;
  logoGap?: number;
  logoSize?: number;
  accounts?: Map<string, BreadAccount> | undefined;
  institutions?: Map<string, BreadInstitution> | undefined;
}): JSX.Element | null {
  const accountsContext = useContext(AccountsContext);
  const institutionsContext = useContext(InstitutionsContext);

  const localAccounts = accounts ?? accountsContext;
  const localInstitutions = institutions ?? institutionsContext;

  if (account_id == null) {
    return null;
  }
  const account = localAccounts.get(account_id);
  if (account === undefined) {
    return null;
  }

  const institution =
    account.institution_id !== null
      ? localInstitutions.get(account.institution_id)
      : undefined;
  return (
    <div className={styles.inlineContainer}>
      <InstitutionLogo
        institution={institution}
        size={logoSize}
      ></InstitutionLogo>
      <HorizontalSpacer width={logoGap} />
      <div className={styles.inlineTextbox}>{account.name}</div>
    </div>
  );
}
